import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  FormGroup,
  Col,
  Row,
  Button,
  Container,
  FormControl,
} from "react-bootstrap";
import logo from "../Assets/images/hippiimage.jpeg";
import { postForgotService } from "../Service/ForgotService";
import { emailSignupService } from "../Service/SignupServices";
import { useHistory } from "react-router-dom";
import { imageAssets } from "../Assets/AssetsConstants/AssetsConstants";
import { style } from "d3";
import showpswdimg from '../Assets/images/show-pswd.svg';
import hidepswdimg from '../Assets/images/hide-pswd.svg';
import { ResetPasswordService } from "../Service/ResetPasswordService";
import { validateOTPService } from "../Service/ValidateOTPService";
import { sendOTPService } from "../Service/SendOTPService";


export default function Forgot() {
  const [forgotEmail, setForgotEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [newPassword, setNewPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [isRevealPswd, setIsRevealPswd] = useState(false);
  const [isRevealRetypePswd, setIsRevealRetypePswd] = useState(false);
  const [checkVar, setCheckVar] = useState(false);
  const [otpButton,sendOtpButton]=useState(true)
  const [resetPasswordButton,setResetPasswordButton]=useState(true);
  const [userId,setUserId]=useState(null);
  const THREE_MINUTES = 90;
  const [timeLeft, setTimeLeft] =useState(THREE_MINUTES)


  const inputRefs = useRef([]);
  const pswdValidate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/
  const emailValidate =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const history = useHistory();

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);
      
      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  useEffect(() => {
    console.log("setting it to 180")
    setTimeLeft(90); 
  }, [showOtpInput]);


  useEffect(() => {
    if (showOtpInput && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [showOtpInput]);

  const checkEmail = async (e) => {
    sendOtpButton(true)
    setSuccessMsg("")
    const email = e.target.value;
    setForgotEmail(email);
    setErrorMsg(""); // Clear previous error messages

    if (!email) {
      setErrorMsg("Please enter your email address.");
      return;
    }

    if (!emailValidate.test(email)) {
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    // Only make the API call if the email is valid
    let data = { email: email };
    const response = await emailSignupService(data);
    console.log(response,"responseeee")
    if (response.status === "success") {
      if (!response.data.emailExists) {
        setErrorMsg(response.data.message);
      
      } else {
        sendOtpButton(false)
        setSuccessMsg("Email exists; send OTP to reset password.");
        setUserId(response.data.user_id)
      }
    }
  };

  const sendOtpHandler = async (e) => {
    e.preventDefault();
    sendOtpButton(true)
    if (!forgotEmail) {
      setErrorMsg("Please enter your email address.");
      return;
    }

    // Here you would typically make an API call to send the OTP
    // For now, we'll just simulate it
    const body={
      email:forgotEmail,
      userId
    }
    console.log("body",body)
    const  response=await sendOTPService(body)
 
    console.log(response,"response")
  if(response.data.status===200){
    setSuccessMsg(response.data.message);
    
    // Simulate a delay before showing OTP input
   setTimeout(()=>{
    setShowOtpInput(true);
    setSuccessMsg(""); // Clear the success message after showing OTP input
   },1000)
   
  

    
  }
  
 
  };

  const handleOtpChange = (element, index) => {
    const value = element.value;
    
    // Only keep the last digit if more than one digit is entered
    const singleDigit = value.slice(-1);
    
    setOtp(prevOtp => {
      const newOtp = [...prevOtp];
      newOtp[index] = singleDigit;
      return newOtp;
    });
  
    // Move to next input if value is entered (keeping your existing focus behavior)
    if (singleDigit && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const validateOtpHandler =async (e) => {
    e.preventDefault();
    setErrorMsg("")
    setSuccessMsg("")
    const enteredOtp = otp.join("");
    if (enteredOtp === "") {
      setErrorMsg("Please enter the OTP.");
      return;
    }
    console.log(enteredOtp,"first otp")
    const otpBody={
      otp:parseInt(enteredOtp),
      userId
    }
    console.log(otpBody,"otpbodyyyyyyyyyy")
    const response=await validateOTPService(otpBody)
    console.log(response,"responseeeeeeee")
 
    if(response?.status==="Success"){
      setSuccessMsg("OTP Validated Successfully");
      console.log("Hello")
      setTimeout(()=>{
        setShowOtpInput(false);
        setShowPasswordReset(true);
        setSuccessMsg("")
  
      },1000)

    }
    else{
      setErrorMsg(response?.data)

    }
   
   
  };

  const handlePasswordReset = async(e) => {
   setResetPasswordButton(true)

    e.preventDefault();
    setErrorMsg("")
    setCheckVar(true);
    const body={
      newPassword,
      userId
    }
    console.log(newPassword,retypePassword)
  console.log(body,"body")
  if(newPassword===retypePassword){
    setResetPasswordButton(false)
  }
  
    console.log(newPassword,'valueeeeeeeeeeeeeeeeeeeee')
   
    // console.log(response,"responseeeeeeeee reset password")
    const response=await ResetPasswordService(body)
    if(  response.data.status ===200 &pswdValidate.test(newPassword )){
  
      setSuccessMsg(response.data.message);

      setTimeout(() => {
        history.push("/signin");
      }, 1000);

    }
    // else{
    //   setErrorMsg("")
    // }
  
  };


  const backToSignIn = () => {
    history.push("/signin");
  };
const handleNewPassword=(e)=>{
 setNewPassword(e.target.value)
 setErrorMsg("")
 handlePasswordMatch(retypePassword,e.target.value)
}

const handleRetypePassword=(e)=>{
  setRetypePassword(e.target.value)
  setErrorMsg("")
  handlePasswordMatch(e.target.value,newPassword);


}

const handlePasswordMatch=(retypePassword,newPassword)=>{
  console.log(newPassword,retypePassword,"passwordssssss")
  setErrorMsg("")
  setResetPasswordButton(true)
if (newPassword.length < 8   ) {
    setErrorMsg("Password must be at least 8 characters long.");
    setResetPasswordButton(true)
    
  }
  else if (newPassword !== retypePassword && retypePassword.length > 0 ) {
    setErrorMsg("Passwords do not match.");
    setResetPasswordButton(true)
  
  
  }
  else{
    if(retypePassword===newPassword){
      setResetPasswordButton(false)
    }
  }
}
const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

  return (
    <div className="whSigninBg">
      <div className="whSigninBgOverlay">
        <div className="whSigninPanel">
          <div className="whForgotContainer">
            <div className="d-flex justify-content-center">
              <img
                src={imageAssets.WehouseLogo}
                className="hippi-signin-icon"
                alt="Wehouse"
              />
            </div>
            <div className="forgotField"> 
              <div className="mt-4">
              {!showOtpInput && !showPasswordReset && (
                <>
                  <form onSubmit={sendOtpHandler}>
                    <h1  className="titleLg" >Forgot Password </h1>
                    <Form.Group className="email-layout" style={{marginBottom:5}}>
                      <Form.Label className="password-label" aria-required="true">Email</Form.Label>
                      <Form.Control 
                        value={forgotEmail} 
                        onChange={checkEmail}  
                        name="Email" 
                        className="email-field" 
                        required 
                        type="email"
                      />
                    </Form.Group>
                    {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
                    {successMsg && <p style={{ color: "green" }}>{successMsg}</p>}
                  
                    <div style={{ display: "flex",marginTop:10 }}>
                    <button  
                          className="forgotBtn" 
                          type="submit"
                          style={{ 
                            marginRight: 5,
                            marginTop: 0,
                            opacity: otpButton ? 0.5 : 1,
                            cursor:otpButton?"not-allowed":"pointer"
                          }}
                          disabled={otpButton}
                        >
                          Send OTP
                        </button>
                      <button 
                        className="forgotBtn" 
                        type="button"
                        style={{ marginRight: 5,marginTop:0,width: 60, backgroundColor: "#6680C2", boxShadow: "none",opacity: 1}}
                        onClick={backToSignIn}
                      >
                        Back
                      </button>
                    </div>
                    
                  </form>
                 
                </>
              )}

              {showOtpInput && (
                <div>
                     <h1  className="titleLg" style={{textAlign:"center"}}>Forgot Password </h1>
                  <p style={{ color: "#888", marginBottom: "10px", textAlign: "center" }}>
                    Enter OTP
                  </p>
                  <form onSubmit={validateOtpHandler}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      {otp.map((data, index) => {
                        return (
                          <input
                            style={{
                              width: "50px",
                              height: "50px",
                              fontSize: "20px",
                              textAlign: "center",  
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              marginRight: index < otp.length - 1 ? "8px" : "0",
                            }}
                            type="number"
                            name="otp"
                            maxLength={1}
                            key={index}
                            value={data}
                            onChange={(e) => handleOtpChange(e.target, index)}
                            onFocus={(e) => e.target.select()}
                            ref={(input) => (inputRefs.current[index] = input)}
                            required
                          />
                        );
                      })}
                    </div>
                    <div   style={{display: "flex",alignItems: "center",justifyContent: "center",backgroundColor: "#ffffff",borderRadius: "8px",padding: "10px",width: "100px",margin: "10px auto",}}>
                    <p       style={{color: "#007bff",margin: "0",fontSize:"1.2em",color:"black"}}>{formatTime(timeLeft)}</p>
                    </div>
                    <div style={{textAlign:"center",marginBottom:10}}  >
                      <button className="forgotBtn" type="submit" style={{width:100,marginTop:0}}>Validate OTP</button>
                    </div>
                  </form>
                  {errorMsg && <p style={{ color: "red",textAlign:"center" }}>{errorMsg}</p>}
                  {successMsg && <p style={{ color: "green",textAlign:"center" }}>{successMsg}</p>}
                </div>
              )}

              {showPasswordReset && (
                <div>
                  <form >
                  <h1  className="titleLg"> Forgot Password </h1>
                  <Form.Group className="password-layout" style={{marginBottom:10}}>
                  <Form.Label className="password-label" aria-required="true">Enter new password</Form.Label>
                  <div className="pswdField">
                    <Form.Control 
                      type={isRevealPswd ? "text" : "password"}
                      value={newPassword} 
                      onChange={handleNewPassword}  
                      name="NewPassword" 
                      className="password-field" 
                      required 
                      onPaste={(e)=>e.preventDefault()}
                      onCopy={(e)=>e.preventDefault()}
                    />
                    <img
                      title={isRevealPswd ? "Hide password" : "Show password"}
                      src={isRevealPswd ? showpswdimg : hidepswdimg}
                      onClick={() => setIsRevealPswd(prevState => !prevState)}
                      className="pswd-icon"
                    />
                  </div>
                </Form.Group>

                <Form.Group className="password-layout" style={{marginBottom:10}}>
              <Form.Label className="password-label" aria-required="true">Confirm new password</Form.Label>
                    <div className="pswdField">
                      <Form.Control 
                        type={isRevealRetypePswd ? "text" : "password"}
                        value={retypePassword} 
                        onChange={handleRetypePassword}  
                        name="RetypePassword" 
                        className="password-field" 
                        required 
                        onPaste={(e)=>e.preventDefault()}
                        onCopy={(e)=>e.preventDefault()}
                      />
                      <img
                        title={isRevealRetypePswd ? "Hide password" : "Show password"}
                        src={isRevealRetypePswd ? showpswdimg : hidepswdimg}
                        onClick={() => setIsRevealRetypePswd(prevState => !prevState)}
                        className="pswd-icon"
                      />
                    </div>
            </Form.Group>
                    <p >{checkVar && !pswdValidate.test(newPassword ) && <small style={{color:"#FF5818",fontSize:13}}>Password must be at least 8 characters long,  <br /> with at least one uppercase letter, one lowercase letter, one digit, and one special character (@, #, $, *).
                      </small>}</p>
                    {errorMsg && <p style={{ color: "red",textAlign:"center"}}>{errorMsg}</p>}
                    {successMsg && <p style={{ color: "green",textAlign:"center"}}>{successMsg}</p>}
                    <div >
                      <button className="forgotBtn" type="submit" style={{width:150,marginTop:10,  opacity: resetPasswordButton ? 0.5 : 1}} 
                      onClick={handlePasswordReset}
                      
                      disabled={  resetPasswordButton}
                      >Reset Password</button>
                    </div>
                  </form>
                </div>
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// export default function Forgot() {
//     const [forgotEmail, setForgotEmail] = useState("");
//     const [errorMsg, setErrorMsg] = useState("");
//     const [successMsg, setSuccessMsg] = useState("");
//     const [submitHandler, setSubmitHandler] = useState("");
//     const [message, setMessage] = useState("")

//     const emailValiadte = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

//     const history = useHistory();

//     // checkEmail:
//     const checkEmail = async () => {
//         if (emailValiadte.test(forgotEmail)) {
//             let data = {
//                 email: forgotEmail
//             }

//             const response = await emailSignupService(data)
//             // console.log('check-email---', response)
//             if (response.status === "success") {
//                 if (!response.data.emailExists) {
//                     setErrorMsg(response.data.message);
//                     // setMessage(response.data.message)
//                 }
//                 else {
//                     setSuccessMsg(response.data.message)
//                     // setMessage("You should soon receive an email allowing you to reset your password")
//                 }

//             }
//         }
//     }

//     const forgotEmailChange = (e) => {
//         setForgotEmail(e.target.value)
//     }

//     const submitForgotHandler = async (e) => {
//         e.preventDefault();
//         let data = {
//             email: forgotEmail
//         }

//         const emailResponse = await emailSignupService(data)
//         console.log('emailResponse:', emailResponse);
//         if (emailResponse.status === "success" && emailResponse.data.emailExists) {

//             const forgotPasswordResponse = await postForgotService(data);
//             console.log("forgotresponce:", forgotPasswordResponse)
//             if(forgotPasswordResponse.status === "success" && forgotPasswordResponse.data.status===200){
//                 setSuccessMsg(forgotPasswordResponse.data.message)
//                 // setMessage(forgotPasswordResponse.data.message)
//                 setTimeout(() => {
//                     history.push('/signin')
//                 }, 4000);

//             }else{

//             }

//         }else{

//         }
//     }

//     const backToSignIn = () => {
//         history.push('/signin')
//     }

//     return (
//         <div className="whSigninBg">
//             <div className="whSigninBgOverlay">

//                 {/* <div className="col-sm-6 hippi-image-col">
//                     <img className="hippi-image" src={logo} alt="hippi" />
//                 </div> */}
//                  <div className="whSigninPanel">
//                 <div className="whForgotContainer">

//                         <div className="d-flex justify-content-center">
//                         {/* <img src={imageAssets.WehouseLogo} className="hippi-signin-icon"  alt="0hippi" /> */}
//                         {/* <img src="https://wehouse-images.s3.ap-south-1.amazonaws.com/wh-logo.png" className="logo" alt="loading...." /> */}
//                         <img src={imageAssets.WehouseLogo} className="hippi-signin-icon"  alt="0hippi" />

//                             {/* <svg width="282" height="66" viewBox="0 0 282 66" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                 <path d="M127.413 64.9579H122.367L118.447 55.0439L115.112 45.0857L111.823 55.135L107.993 64.9579H102.944L91.362 33.4147H98.03L105.465 56.1715L113.126 33.4147H117L124.887 56.1715L132.096 33.4147H138.767L127.413 64.9579Z" fill="#F8991D" />
//                                 <path d="M148.19 42.0658C140.979 42.0658 136.383 46.9324 136.383 53.6913C136.383 60.8104 140.938 65.5417 148.595 65.5417C152.126 65.6215 155.55 64.3293 158.148 61.9366L154.634 58.4668C152.958 59.8377 150.85 60.5711 148.685 60.5371C144.809 60.5371 142.422 58.5538 142.06 55.8058H159.41C160.265 46.6592 155.624 42.0617 148.188 42.0617L148.19 42.0658ZM142.15 51.2539C142.528 49.9259 143.354 48.7696 144.487 47.9809C145.621 47.1923 146.992 46.82 148.369 46.9269C151.523 46.9269 153.777 48.3692 154.137 51.2539H142.15Z" fill="#F8991D" />
//                                 <path d="M167.793 33.4147V45.762C168.589 44.6808 169.638 43.8113 170.848 43.2299C172.058 42.6486 173.392 42.373 174.733 42.4275C181.042 42.4275 183.836 46.7061 183.836 53.2414V64.9579H178.339V53.2869C178.339 49.2319 176.22 47.519 173.291 47.519C172.526 47.5438 171.774 47.7224 171.08 48.0443C170.385 48.3661 169.763 48.8246 169.25 49.3924C168.737 49.9601 168.343 50.6255 168.093 51.3487C167.843 52.0719 167.741 52.8381 167.793 53.6016V64.9565H162.296V33.4147H167.793Z" fill="#1A1818" />
//                                 <path d="M198.031 42.2909C195.742 42.2996 193.507 42.9862 191.608 44.2641C189.709 45.5419 188.232 47.3537 187.362 49.4707C186.492 51.5876 186.269 53.9149 186.721 56.1585C187.173 58.4021 188.279 60.4616 189.901 62.0768C191.522 63.6921 193.586 64.7907 195.831 65.234C198.077 65.6773 200.403 65.4454 202.517 64.5676C204.631 63.6897 206.437 62.2053 207.708 60.3017C208.978 58.3982 209.656 56.1608 209.656 53.8721C209.722 52.3299 209.466 50.7909 208.905 49.353C208.343 47.9152 207.488 46.61 206.395 45.5205C205.301 44.4311 203.993 43.5813 202.553 43.0253C201.113 42.4692 199.573 42.2191 198.031 42.2909ZM198.076 60.406C194.065 60.406 192.038 57.2522 192.038 53.8721C192.038 50.5376 194.108 47.2927 198.076 47.2927C198.906 47.3229 199.722 47.5177 200.477 47.8658C201.231 48.2139 201.909 48.7084 202.471 49.3204C203.032 49.9325 203.467 50.65 203.749 51.4314C204.031 52.2127 204.156 53.0424 204.115 53.8721C204.115 57.2509 202.087 60.406 198.076 60.406Z" fill="#1A1818" />
//                                 <path d="M218.175 42.7422V54.3676C218.175 57.7477 220.023 60.3163 223.538 60.3163C224.323 60.2955 225.097 60.1163 225.812 59.7896C226.527 59.4628 227.169 58.9952 227.699 58.4147C228.229 57.8342 228.636 57.1528 228.897 56.4111C229.157 55.6695 229.265 54.8829 229.215 54.0985V42.7435H234.669V65.0035H229.757L229.397 61.985C228.455 63.0479 227.296 63.8958 225.997 64.4712C224.699 65.0465 223.292 65.3359 221.872 65.3195C216.554 65.3195 212.678 61.3087 212.678 54.4159V42.7449L218.175 42.7422Z" fill="#1A1818" />
//                                 <path d="M253.145 48.6453C252.409 47.9632 251.542 47.4362 250.598 47.0955C249.654 46.7547 248.65 46.6073 247.648 46.6619C245.034 46.6619 243.593 47.4735 243.593 48.8703C243.593 50.3126 244.9 51.1241 247.733 51.3036C251.924 51.5796 257.242 52.5209 257.242 58.4226C257.242 62.3424 254.043 65.7225 247.688 65.7225C245.789 65.8539 243.885 65.5669 242.11 64.8817C240.334 64.1965 238.731 63.1299 237.413 61.7572L240.117 57.8361C242.23 59.7332 244.94 60.8331 247.778 60.9457C249.848 60.9912 251.789 59.9091 251.789 58.2874C251.789 56.7554 250.527 56.1246 247.372 55.9411C243.181 55.625 238.179 54.093 238.179 49.04C238.179 43.9029 243.496 42.1017 247.553 42.1017C249.117 41.9978 250.686 42.2029 252.17 42.7054C253.655 43.208 255.026 43.998 256.205 45.0305L253.145 48.6453Z" fill="#1A1818" />
//                                 <path d="M270.677 42.0658C263.467 42.0658 258.871 46.9324 258.871 53.6913C258.871 60.8104 263.425 65.5417 271.083 65.5417C274.614 65.6217 278.039 64.3295 280.637 61.9366L277.122 58.4668C275.446 59.8375 273.339 60.5709 271.174 60.5371C267.298 60.5371 264.911 58.5538 264.549 55.8058H281.899C282.755 46.6592 278.114 42.0617 270.679 42.0617L270.677 42.0658ZM264.64 51.2539C265.018 49.9259 265.844 48.7696 266.978 47.9809C268.111 47.1923 269.483 46.82 270.859 46.9269C274.013 46.9269 276.267 48.3692 276.628 51.2539H264.64Z" fill="#1A1818" />
//                                 <path d="M35.8538 23.8858L27.1983 40.0563L17.8126 23.8858H0.874146L18.5703 56.1826L18.4682 56.3744L23.2163 65.2464H30.9747L35.8249 56.184L44.6585 39.6809L36.2086 23.8858H35.8538Z" fill="#1A1818" />
//                                 <path d="M62.1186 40.0563L53.4631 23.8858H36.2099L44.6598 39.674L58.3423 65.2395H65.8964L70.7466 56.1771L100.378 0H84.7533L62.1186 40.0563Z" fill="#F8991D" />
//                                 <path d="M47.4728 57.1984H41.1443V65.2395H47.4728V57.1984Z" fill="#1A1818" />
//                             </svg> */}
//                         </div>
//                         <div className="forgotField">
//                             <h1 className="titleLg">Forgot Password</h1>

//                             { successMsg ?
//                              <div> {successMsg && <p style={{ color: "green" }}>{successMsg}</p>  }</div>
//                               : <div> {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}</div> }

//                                {/* <p>{message}</p> */}

//                             <div className="mt-4">
//                                 <Form.Group className="email-layout">
//                                     <Form.Label className="password-label">  Email</Form.Label>
//                                     <Form.Control value={forgotEmail} onChange={forgotEmailChange} name="Email" className="email-field" onBlur={checkEmail} />
//                                 </Form.Group>
//                                 <div style={{display:"flex"}}>
//                                 <button className="forgotBtn" style={{marginTop:20,marginRight:5}} >Send OTP</button>
//                                 {/* <button onClick={submitForgotHandler} className="forgotBtn" >Reset password</button> */}
//                                 <button className="forgotBtn" style={{marginTop:20,marginRight:5,width:60,backgroundColor:"#A1B7C8",boxShadow:"none"}}onClick={backToSignIn} >Back </button>

//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }
